var $window, dealList, expChangeToWebp, fixiOS5, getElementPositions, getFold, getImagesToLoad, getTouchDealCardHeight, progressiveLoad, setTouchImageDimensions, setWebpSetting, touchDealCardHeight, unbindLazyloaderEvent, withinViewport;

touchDealCardHeight = dealList = void 0;

$window = $(window);


/*
 * With IOS5 force loading images when navigating with back button.
 * Non optimal workaround.
 *
 * @param {Array} allLazyImages[] - All images to be lazyloaded
 */

fixiOS5 = function(allLazyImages) {
  if (/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)) {
    return $window.one('pageshow', function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        return $(allLazyImages).trigger('appear');
      }
    });
  }
};


/*
 * Determine image positions within the document
 *
 * @param   {Array} images[] - Array with images nodes
 * @returns {Array} pos[]    - Array containing the current images position in the document
 */

getElementPositions = function(images) {
  var img, left, pos, ref, right, top;
  pos = [];
  images = images.slice();
  while ((img = images.shift())) {
    ref = img.getBoundingClientRect(), top = ref.top, left = ref.left, right = ref.right;
    pos.push({
      left: left,
      top: top,
      right: right
    });
  }
  return pos;
};


/*
 * Returns the top/bottom coordinate of the visible viewport in doc coords
 *
 * @returns {Object}
 */

getFold = function() {
  return {
    height: window.innerHeight || $window.height(),
    width: window.innerWidth || $window.width()
  };
};


/*
 * Filter out the `images` that are visible, but not yet loaded
 *
 * @param   {Array} images[] - Images to lazyload
 * @returns {Array} toLoad[] - Images that haven't been loaded
 */

getImagesToLoad = function(images) {
  var img, toLoad;
  toLoad = [];
  images = images.slice();
  while ((img = images.shift())) {
    if (!img.loaded && img.offsetHeight) {
      toLoad.push(img);
    }
  }
  return toLoad;
};


/*
 * Returns potential deal card height
 *
 * @returns {Number} height - Deal card height
 */

getTouchDealCardHeight = function() {
  var height;
  height = 0;
  if (typeof Touch !== "undefined" && Touch !== null ? Touch.Utils.getViewportInformation : void 0) {
    height = Touch.Utils.getViewportInformation({
      offset: dealList[0].offsetLeft * 2
    }).dcH;
  }
  return height;
};

expChangeToWebp = function(url, settings) {
  if (settings.webp && url.match(/(img(\d?).grouponcdn.com).*(jpg|png)$/)) {
    Finch.experiment('LS-2718-webp-images', {
      Control: function() {},
      Treatment: function() {
        return url = url.replace(/(q\d+)?(.jpg|.png)$/, '.webp');
      }
    });
  }
  return url;
};


/*
 * Sets html height attribute to touch dealcard images to speed up their rendering
 *
 * @param {Array} collection[] - Collection of images nodes
 */

setTouchImageDimensions = function(collection) {
  var i, img, len;
  window.removeEventListener('load', setTouchImageDimensions, false);
  if (!(dealList = document.querySelectorAll('.t-deals')).length) {
    return;
  }
  if ((touchDealCardHeight = getTouchDealCardHeight())) {
    for (i = 0, len = collection.length; i < len; i++) {
      img = collection[i];
      if (img.parentNode.parentNode.parentNode.className.match(/t-deals/)) {
        img.height = touchDealCardHeight;
      }
    }
  }
};

setWebpSetting = function(settings, override) {
  var ref;
  settings.webp = override != null ? override : (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref = Modernizr.webp) != null ? ref.valueOf() : void 0 : void 0) || $('html').hasClass('webp') || false;
  return settings;
};


/*
 * Unbind the lazyloader event
 */

unbindLazyloaderEvent = function(settings) {
  if (settings.performantScroll) {
    $(settings.container).off(settings.event);
  }
};


/*
 * Determine if an images is within the viewport + threshold
 *
 * @param   {Object}  fold      - Viewport information
 * @param   {Object}  imgPos    - Image information
 * @param   {Number}  threshold - Threshold to consider loading images within
 * @returns {Boolean}
 */

withinViewport = function(fold, imgPos, threshold) {
  var left, right, top;
  left = imgPos.left, top = imgPos.top, right = imgPos.right;
  if (top <= -threshold) {
    return false;
  }
  if (top >= fold.height + threshold) {
    return false;
  }
  if (left <= -threshold) {
    return false;
  }
  if (right >= fold.width + threshold) {
    return false;
  }
  return true;
};


/*
 * progressive load image
 */

progressiveLoad = function(el, settings) {
  var highQualityImage, highQualitySrc;
  if (!el.loaded && $(el).hasClass('progressive-load') && (highQualitySrc = el.getAttribute('data-high-quality'))) {
    highQualityImage = new Image();
    highQualityImage.style.display = 'none';
    $(highQualityImage).on('load', function() {
      if (el.nodeName === 'IMG') {
        el.src = highQualitySrc;
      } else {
        el.style.backgroundImage = "url('" + highQualitySrc + "')";
      }
      el.style['-webkit-filter'] = 'blur(0px)';
      el.style['filter'] = 'blur(0px)';
      return el.parentNode.removeChild(this);
    });
    highQualityImage.src = expChangeToWebp(highQualitySrc, settings);
    el.parentNode.appendChild(highQualityImage);
  }
  el.loaded = true;
};

(function(jQuery, window, document) {
  "use strict";
  return $.fn.lazyload = function(options) {
    var $container, OPTS, allLazyImages, hasModernizr, initLazyLoading, loadImage, onScroll, ref, requestTick, resizeTimer, settings, ticking;
    if (options == null) {
      options = {};
    }
    allLazyImages = this.get();
    resizeTimer = null;
    OPTS = {
      event: 'scroll.lazyload',
      threshold: 400,
      webp: false,
      skip_invisible: true,
      skip_initial_check: false,
      container: window,
      performantScroll: false,
      isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
      placeholder: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    };
    settings = _.assign({}, OPTS, options);
    if (settings.resetImageDimensions) {
      setTouchImageDimensions(allLazyImages);
      return;
    }
    $container = (ref = settings.container) === window || ref === (void 0) ? $window : $(settings.container);
    ticking = false;

    /*
     * Global scroll handler
     */
    onScroll = function() {
      var fold, imagesNotLoaded, img, pos, positions, threshold;
      ticking = false;
      if (!settings.skip_invisible) {
        $(allLazyImages).trigger('appear');
        unbindLazyloaderEvent(settings);
        return;
      }
      imagesNotLoaded = getImagesToLoad(allLazyImages);
      if (!imagesNotLoaded.length) {
        unbindLazyloaderEvent(settings);
        return;
      }
      fold = getFold();
      allLazyImages = [];
      positions = getElementPositions(imagesNotLoaded);
      threshold = settings.threshold;
      while ((img = imagesNotLoaded.shift())) {
        pos = positions.shift();
        if (withinViewport(fold, pos, threshold)) {
          $(img).triggerHandler('appear');
        } else {
          allLazyImages.push(img);
        }
      }
    };

    /*
     * Image loading handler
     */
    loadImage = function() {
      var url, url2x;
      url = this.getAttribute('data-original');
      if (settings.isRetina && (url2x = this.getAttribute('data-original-2x'))) {
        url = url2x;
      }
      url = expChangeToWebp(url, settings);
      if (this.nodeName === 'IMG') {
        this.src = url;
      } else {
        this.style.backgroundImage = "url('" + url + "')";
      }
      progressiveLoad(this, settings);
    };

    /*
     * Asynchronous scroll handler
     */
    requestTick = function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    };
    initLazyLoading = function(onScroll) {
      var images, img;
      if (resizeTimer === null) {
        $window.on('resize', function() {
          if (resizeTimer) {
            clearTimeout(resizeTimer);
          }
          return resizeTimer = setTimeout(onScroll, 100);
        });
      }
      images = allLazyImages.slice();
      while ((img = images.shift())) {
        if (img.nodeName === 'IMG' && img.src === '') {
          img.loaded = false;
          img.src = settings.placeholder;
        }
      }
      setTouchImageDimensions(allLazyImages);
      $(allLazyImages).one('appear', loadImage);
      fixiOS5(allLazyImages);
      $container.on(settings.event, requestTick);
      $(function() {
        settings = setWebpSetting(settings, options != null ? options.webp : void 0);
        if (!settings.skip_initial_check) {
          return requestTick();
        }
      });
      return window.addEventListener('load', setTouchImageDimensions(allLazyImages), false);
    };
    if (options != null ? options.webp : void 0) {
      settings = setWebpSetting(settings, options.webp);
    }
    hasModernizr = window.Modernizr && typeof Modernizr.on === 'function';
    if (!settings.webp && hasModernizr && ((typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.webp : void 0) == null)) {
      return Modernizr.on('webp', function() {
        settings.webp = Modernizr.webp.valueOf();
        return initLazyLoading(onScroll);
      });
    } else {
      return initLazyLoading(onScroll);
    }
  };
})(jQuery, window, document);

module.exports = {
  getElementPositions: getElementPositions,
  getFold: getFold,
  getImagesToLoad: getImagesToLoad,
  getTouchDealCardHeight: getTouchDealCardHeight,
  setTouchImageDimensions: setTouchImageDimensions,
  setWebpSetting: setWebpSetting,
  withinViewport: withinViewport
};

//# sourceMappingURL=data:application/json;base64,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
